import { PanelTheme } from 'types/graphql-global-types';

const ThemeOne: string[] = ['#EF8B72', '#A9A9A9', '#787FE8', '#58C5E3', '#CF6DAC', '#EFE790', '#34EBC7', '#9BC77C'];
const ThemeTwo: string[] = ['#97B0BD', '#F8A8C6', '#58B8C4', '#7561B5', '#EBD555', '#BE90CA', '#E0A58E', '#C8D369'];
const ThemeThree: string[] = ['#68CFF5', '#DBDF5C', '#9379CD', '#91E5BE', '#E890A2', '#EDA5EE', '#ECC7CE', '#899BC8'];
const ThemeFour: string[] = ['#7D6BA0', '#5E9CBD', '#2B526C', '#AB8575', '#EB6781', '#B1B874', '#F8B645', '#007A81'];

export const getThemeColours = (theme: PanelTheme) => {
    switch (theme) {
        case PanelTheme.THEME_1:
            return ThemeOne;
        case PanelTheme.THEME_2:
            return ThemeTwo;
        case PanelTheme.THEME_3:
            return ThemeThree;
        case PanelTheme.THEME_4:
            return ThemeFour;
        // There should never be a None value, this is only temporary, until all panels have been migrated
        case PanelTheme.NONE:
        default:
            return ThemeOne;
    }
};
